<template>
  <div class="app-wrapp">
    <section class="bg-clay">
      <div class="article-wrapper">
        <div class="article-head article-head--a6">
          <div class="article-head__img article-head__img--a6 img-w animated fadeInLeft">
            <img src="@/assets/img/article6/img1.png" alt="">
          </div>
          <h2 class="article-head__title article-head__title--a6">
            <div class="animated fadeInRight" >
              {{ 'Миллионы россиян боялись брать больничный по уходу за ребенком. Почему теперь это изменится?' | typograf }}
            </div>
            <div class="article-head__line article-head__line--61 img-w">
              <img src="@/assets/img/article6/line1.png" alt="">
            </div>
          </h2>
        </div>
      </div>
    </section>

    <section class="article-text bg-clay">
      <div class="mobile-hidden article__img article__img13 img-w"  v-animate-onscroll="'animated fadeInLeft'">
        <img src="@/assets/img/article6/img13.png" alt="">
      </div>
      <div class="mobile-hidden article__img article__img10 img-w" v-animate-onscroll="'animated fadeInRight'">
        <img src="@/assets/img/article6/img10.png" alt="">
      </div>
      <div class="article-wrapper article-wrapper--mt">
        <h3 class="article-text__h3" style="opacity: 0;" v-animate-onscroll="'animated fadeInUp'">
          {{ '«Страх потерять деньги и волнение за ребенка»' | typograf }}
        </h3>
        <p class="article-text__subtitle" style="opacity: 0;" v-animate-onscroll="'animated fadeInUp'">
          {{ 'Когда в семье появляется ребенок, это всегда счастье. Но вместе с ним приходят дополнительные расходы и проблемы. У молодых родителей появляется множество новых обязанностей, которые поначалу кажутся несущественными. Идет время, груз забот накладывается на усталость. Жить в таком ритме порой просто физически тяжело.' | typograf }}
        </p>
        <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
          {{ 'Полегче родителям, в особенности маме, становится, когда сын или дочь подрастают и их можно оставлять в детском саду, а самой выйти на работу, чтобы наполнить существенно опустевший семейный бюджет.' | typograf }}
        </p>
        <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
          {{ 'Хорошо, когда есть бабушки и дедушки, готовые помочь с воспитанием детей, или возможность нанять няню на полноценный рабочий день. Но так бывает далеко не всегда.' | typograf }}
        </p>
        <div class="article-text__quote" v-animate-onscroll="'animated fadeInUp'">
          <span class="char"
                v-for="(letter, index) in titles[0]"
                :key="letter.id"
                :style="{ animationDelay: 0.1*index + 's'}" v-html="letter + ' '"></span>
        </div>
        <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
          {{ 'Родилась в небольшом поселке между Омском и Новосибирском. Больших перспектив для нее там не открывалось — либо пойти по стопам родителей и стать агрономом, либо пойти продавщицей в магазин.' | typograf }}
        </p>
        <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
          {{ 'Поэтому она поехала учиться в Новосибирск, а после университета — работать в Москву. Устроилась в небольшую компанию специалистом по найму, работала "в серую", без трудовой книжки. Там же встретилась с молодым человеком, с которым еще до переезда познакомилась в интернете… Как-то получилось так, что эти отношения, как она считала «на пару месяцев», не закончились ни через год, ни через четыре.' | typograf }}
        </p>
        <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
          {{ 'Когда ей исполнилось 27 лет, они решили расписаться,  и уже через 9 месяцев у них родилась первая дочь, а за ней, через полтора года, и вторая. Тут уже стало не до работы — знай только меняй подгузники, корми, укладывай спать и успокаивай, когда ребенок испугался чудовища, спрятавшегося под кроватью.' | typograf }}
        </p>
        <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
          {{ 'Годы шли, дети росли, и Ольга решила, что пора начать свою карьеру заново, теперь уже правильно. Устроилась специалистом службы поддержки.' | typograf }}
        </p>
      </div>
      <div class="article-text__shifted-box">
        <div class="article__img article__img2 img-w" v-animate-onscroll="'animated fadeInRight'">
          <img src="@/assets/img/article6/img2.png" alt="">
        </div>
       <!-- <div class="article__line article__line2 img-w"  v-animate-onscroll="'animated fadeInDown'">
          <img src="@/assets/img/article6/line2.png" alt="">
        </div>-->
        <div class="article-wrapper article-wrapper--shifted-r">
          <div class="article-text__quote" v-animate-onscroll="'animated fadeInUp'">
            <span class="char"
                  v-for="(letter, index) in titles[1]"
                  :key="letter.id"
                  :style="{ animationDelay: 0.1*index + 's'}" v-html="letter + ' '"></span>
          </div>
          <div class="article-text__quote2"  v-animate-onscroll="'animated fadeInUp'">
            <div class="article-text__quote-icon img-w">
              <img src="@/assets/img/quote-black.png" alt="">
            </div>
            {{ '«И тут меня накрывали чувства, — рассказывает она. — Во-первых, это беспокойство, что с ребенком что-то не так. Во-вторых, конечно, раздражение, потому что нарушается некий порядок вещей: ребенок не может ходить в садик, и, соответственно, на тебя наваливается не только необходимость присмотра и ухода за ним, исполнения каких-то процедур, которые прописывает врач, но и необходимость кормить его и развлекать».' | typograf }}
          </div>
          <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
            {{ 'Как говорит Ольга, если при этом еще и работать, то  добавляется и чувство вины: ты будто бросаешь своего ребенка, и он остается без необходимой заботы.' | typograf }}
          </p>
          <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
            {{ 'Женщина признается, что у нее были и личные психологические сложности с тем, чтобы взять больничный. «Я не валялась с температурой под 40, но должна была брать больничный. Но почему? Ведь болела не я, а ребенок! Я постоянно ловила себя на этой мысли» — рассуждает она.' | typograf }}
          </p>
          <div class="article-text__quote" v-animate-onscroll="'animated fadeInUp'">
            <span class="char"
                  v-for="(letter, index) in titles[2]"
                  :key="letter.id"
                  :style="{ animationDelay: 0.1*index + 's'}" v-html="letter + ' '"></span>
          </div>
        </div>
      </div>
      <div class="article-text__shifted-box">
        <div class="mobile-hidden article__img article__img11 img-w" v-animate-onscroll="'animated fadeInRight'">
          <img src="@/assets/img/article6/img11.png" alt="">
        </div>
        <div class="mobile-hidden article__img article__img12 img-w" v-animate-onscroll="'animated fadeInLeft'">
          <img src="@/assets/img/article6/img12.png" alt="">
        </div>
        <div class="article-wrapper article-wrapper--pb2">
          <div class="article-text__quote2"  v-animate-onscroll="'animated fadeInUp'">
            <div class="article-text__quote-icon img-w">
              <img src="@/assets/img/quote-black.png" alt="">
            </div>
            {{ '«Психологически не важно количество нулей, ты живешь на всю эту сумму, и для тебя потеря части дохода, независимо от его размера, очень болезненна», — признается Ольга.' | typograf }}
          </div>
          <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
            {{ 'Учитывая стаж, по больничному ей выплачивали всего 60 процентов от средней заработной платы.' | typograf }}
          </p>
          <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
            {{ 'Такая ситуация — не редкость. Дело в том, что, согласно общему правилу, листок нетрудоспособности оплачивается согласно страховому стажу, и если он не превышает пяти лет, выплата составляет всего 60 процентов от среднего заработка. Но и после пяти лет стажа эта сумма составляет 80 процентов, и только после восьми лет больничный оплачивается в размере 100 процентов от среднего заработка.' | typograf }}
          </p>
          <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
            {{ 'Поэтому большинству молодых родителей приходится выбирать: либо брать больничный и терять деньги, либо вести ребенка, если у него нет температуры, с соплями в детский сад, где он заражает других детей.' | typograf }}
          </p>
          <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
            {{ 'Но эта проблема совсем скоро должна исчезнуть.' | typograf }}
          </p>
        </div>
      </div>
      <div class="article-wrapper article-wrapper--pb2">
        <Loading :class="{'is-loading-animated': isLoading}" />
        <div class="observer-move"></div>
        <Layers />
      </div>
    </section>

    <section id="element-container" class="article-text article-text--blue article-text--blue3 -no-blue">
      <div class="article__line article__img14 img-w"  v-animate-onscroll="'animated fadeInLeft'">
        <img src="@/assets/img/article6/img14.png" alt="">
      </div>
      <div class="article__line article__img15 img-w"  v-animate-onscroll="'animated fadeInRight'">
        <img src="@/assets/img/article6/img15.png" alt="">
      </div>
      <div id="element-content">
        <div class="article-wrapper article-wrapper--inner article-wrapper--inner-fot">
          <h3 id="element" class="article-text__h3" v-animate-onscroll="'animated fadeInUp'">
            {{ '«Большой шаг в сторону молодых семей»' | typograf }}
          </h3>
          <p class="article-text__subtitle" v-animate-onscroll="'animated fadeInUp'">
            {{ 'С 1 сентября 2021 года для таких родителей ситуация в корне поменяется. Все благодаря инициативе, выдвигавшейся ранее партией «Единая Россия».' | typograf }}
          </p>
          <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
            {{ 'Теперь больничный по уходу за ребенком в возрасте до восьми лет будет оплачиваться в размере 100 процентов от средней заработной платы вне зависимости от страхового стажа родителей.' | typograf }}
          </p>
          <div class="article-text__quote article-text__quote--blue" v-animate-onscroll="'animated fadeInUp'">
          <span class="char"
                v-for="(letter, index) in titles[3]"
                :key="letter.id"
                :style="{ animationDelay: 0.1*index + 's'}" v-html="letter + ' '"></span>
          </div>
          <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
            {{ 'Владимир Путин коснулся этой проблемы в послании к Федеральному собранию в апреле 2021 года.' | typograf }}
          </p>
          <div class="article-text__quote2"  v-animate-onscroll="'animated fadeInUp'">
            <div class="article-text__quote-icon img-w">
              <img src="@/assets/img/quote.png" alt="">
            </div>
            {{ '«Сейчас размер оплаты больничного по уходу за ребенком зависит от трудового стажа. В целом это, конечно, правильно и справедливо, но получается, что для молодых женщин такие выплаты существенно ниже», — говорил Путин. При этом президент отметил, что «женщины, у которых есть приличный стаж, уже, как правило, и не рожают».' | typograf }}
          </div>
        </div>
        <div class="article-text__shifted-box">
          <div class="article__img article__img3 img-w"  v-animate-onscroll="'animated fadeInLeft'">
            <img src="@/assets/img/article6/img3.png" alt="">
          </div>
          <!-- <div class="article__line article__line3 img-w"  v-animate-onscroll="'animated fadeInLeft'">
             <img src="@/assets/img/article6/line3.png" alt="">
           </div>-->
          <div class="article-wrapper article-wrapper--inner article-wrapper--shifted-left">
            <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
              {{ 'В своем послании Путин поручил правительству определить объем средств, требуемых для осуществления этой меры поддержки, и найти источники ее финансирования.' | typograf }}
            </p>
            <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
              {{ 'Законопроект был принят в тот же день, еще через день прошел в Совете Федерации, после чего был подписан президентом.' | typograf }}
            </p>
            <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
              {{ 'По словам Андрея Исаева, первого заместителя фракции «Единая Россия» в Государственной Думе, это решение — «большой шаг в сторону молодых семей, в сторону их поддержки».' | typograf }}
            </p>
            <div class="article-text__quote article-text__quote--blue" v-animate-onscroll="'animated fadeInUp'">
            <span class="char"
                  v-for="(letter, index) in titles[4]"
                  :key="letter.id"
                  :style="{ animationDelay: 0.1*index + 's'}" v-html="letter + ' '"></span>
            </div>
            <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
              {{ '«Сохранение стопроцентной оплаты больничного означает, что молодые родители смогут воспользоваться больничным листом и оказать необходимую помощь своим детям. Это, несомненно, станет очень серьезной поддержкой для молодых семей», — подчеркивает он. ' | typograf }}
            </p>
            <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
              {{ 'Основательница Национального родительского комитета Ирина Волынец назвала эти поправки в законодательство колоссальной поддержкой для молодых мам, имеющих очень маленький стаж. «Невозможно не идти на больничный, когда болеет ребенок, но в то же время очень трудно жить, особенно если больничный затягивается», — объясняла она.' | typograf }}
            </p>
          </div>
          <div class="article-wrapper article-wrapper--pb article-wrapper--inner">
            <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
              {{ 'Высоко оценила возможность стопроцентной выплаты по больничному по уходу за ребенком и уполномоченный по правам ребенка Ленинградской области Тамара Литвинова. Она назвала эту тему очень серьезной и значимой, потому что «дети дошкольного возраста болеют, и родителям приходится с ними сидеть», а изменения в законодательстве, подписанные президентом, «позволят улучшить материальное состояние семьи». Литвинова также заметила, что и в ее аппарате есть молодые матери, которые будут пользоваться этой возможностью.' | typograf }}
            </p>
            <div class="article-text__quote2"  v-animate-onscroll="'animated fadeInUp'">
              <div class="article-text__quote-icon img-w">
                <img src="@/assets/img/quote.png" alt="">
              </div>
              {{ '«Мои дети уже чуть подросли. Болеют меньше, но если болеют, приходится брать больничный. Это случается нечасто, но хотелось бы, чтобы даже такие случаи не лишали нас дохода», — говорит Ольга Бойко.' | typograf }}
            </div>
            <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
              {{ 'Она подчеркивает, что новое правило, которое позволит получать 100 процентов от среднего месячного заработка на больничном по уходу за ребенком, существенно укрепит доходы ее семьи.' | typograf }}
            </p>
          </div>
        </div>
      </div>
    </section>

    <section class="article-text">
      <div class="mobile-hidden article__img article__img16 img-w">
        <img src="@/assets/img/article6/img16.png" alt="">
      </div>
      <div class="mobile-hidden article__img article__img17 img-w" v-animate-onscroll="'animated fadeInLeft'">
        <img src="@/assets/img/article6/img17.png" alt="">
      </div>
      <div class="article-wrapper article-wrapper--mt">
        <h3 class="article-text__h3" v-animate-onscroll="'animated fadeInUp'">
          {{ 'Дают гарантию' | typograf }}
        </h3>
        <p class="article-text__subtitle" v-animate-onscroll="'animated fadeInUp'">
          {{ 'Глава Минтруда Антон Котяков утверждал, что такие выплаты ежегодно смогут получать полтора миллиона родителей. ' | typograf }}
        </p>
        <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
          {{ 'А премьер-министр России Михаил Мишустин на совещании с вице-премьерами в середине июля заявил, что на эти цели будет выделен из бюджета миллиард рублей. Причем эта мера не затронет работодателей, ведь увеличенные больничные будут оплачиваться напрямую из Фонда социального страхования.' | typograf }}
        </p>
        <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
          {{ 'Для того чтобы больничный по уходу за ребенком до восьми лет был оплачен по новым правилам, не нужно предъявлять никаких дополнительных документов — он будет рассчитан ФСС автоматически на основе информации из больничного листа.' | typograf }}
        </p>
        <div class="article-text__quote article-text__quote--blue" v-animate-onscroll="'animated fadeInUp'">
          <span class="char"
                v-for="(letter, index) in titles[5]"
                :key="letter.id"
                :style="{ animationDelay: 0.1*index + 's'}" v-html="letter + ' '"></span>
        </div>
      </div>
      <div class="article-text__shifted-box">
        <div class="article__img article__img4 img-w" v-animate-onscroll="'animated fadeInLeft'">
          <img src="@/assets/img/article6/img4.png" alt="">
        </div>
        <!--<div class="article__line article__line5 img-w"  v-animate-onscroll="'animated fadeInDown'">
          <img src="@/assets/img/article6/line5.png" alt="">
        </div>-->
        <div class="article-wrapper article-wrapper--shifted">
          <p class="article-text__subtitle" v-animate-onscroll="'animated fadeInUp'">
            {{ 'Это не единственная мера социальной поддержки семей, которую Путин огласил в послании к Федеральному собранию. В начале мая премьер Михаил Мишустин, в свою очередь, утвердил список поручений, которые позволят эти меры поддержки обеспечить.' | typograf }}
          </p>
          <p class="article-text__enlarged" v-animate-onscroll="'animated fadeInUp'">
            {{ 'Помимо больничных, в мае Госдума приняла поправки, которые предусматривают назначение ежемесячной выплаты в размере половины прожиточного минимума в регионе проживания для неполных малообеспеченных семей с детьми до 16 лет включительно. Они вступили в силу с 1 июля 2021 года. К тому же была назначена ежемесячная выплата пособия женщинам, находящимся в трудном материальном положении и вставшим на учет в медицинское учреждение в связи с беременностью в первые 12 недель.' | typograf }}
          </p>
        </div>
      </div>
      <div class="article-wrapper">
        <h3 class="article-text__h3" v-animate-onscroll="'animated fadeInUp'">
          {{ 'Что нужно знать о новых выплатах больничного по уходу за ребенком ' | typograf }}
        </h3>
      </div>
    </section>

    <div class="info info--list">
      <div class="info__columns info__columns--pt">
        <div class="info__column info__column--25">
          <div class="info__icon2 info__icon--61">
            <img src="@/assets/img/article6/i1.png" alt="">
          </div>
          <div class="info__column-title info__column-title--list">
            Начнутся <br>
            с 1 сентября 2021 года
          </div>
        </div>
        <div class="info__column info__column--25">
          <div class="info__icon2 info__icon--61">
            <img src="@/assets/img/article6/i2.png" alt="">
          </div>
          <div class="info__column-title info__column-title--list">
            Равны 100 процентам <br>
            от среднего заработка
          </div>
        </div>

        <div class="info__column info__column--25">
          <div class="info__icon2 info__icon--61">
            <img src="@/assets/img/article6/i3.png" alt="">
          </div>
          <div class="info__column-title info__column-title--list">
            Осуществляются <br> автоматически
          </div>
        </div>

        <div class="info__column info__column--25">
          <div class="info__icon2 info__icon--61">
            <img src="@/assets/img/article6/i4.png" alt="">
          </div>
          <div class="info__column-title info__column-title--list">
            Гарантированы <br>
            государством
          </div>
        </div>
      </div>
      <div class="info__columns">
        <div class="info__column info__column--25">
          <div class="info__icon2 info__icon--61">
            <img src="@/assets/img/article6/i5.png" alt="">
          </div>
          <div class="info__column-title info__column-title--list">
            Идут напрямую <br>
            из Фонда социального <br> страхования
          </div>
        </div>

        <div class="info__column info__column--25">
          <div class="info__icon2 info__icon--61">
            <img src="@/assets/img/article6/i6.png" alt="">
          </div>
          <div class="info__column-title info__column-title--list">
            Не зависят от формы <br> лечения ребенка <br>
            (в стационаре <br>
            или амбулаторно)
          </div>
        </div>

        <div class="info__column info__column--25">
          <div class="info__icon2 info__icon--67">
            <img class="info__icon2--special" src="@/assets/img/article6/i7.png" alt="">
          </div>
          <div class="info__column-title info__column-title--list">
            Максимальная стоимость дня <br>
            на больничном — <br>
            2434 рубля
          </div>
        </div>

        <div class="info__column info__column--25">
          <div class="info__icon2 info__icon--61">
            <img src="@/assets/img/article6/i8.png" alt="">
          </div>
          <div class="info__column-title info__column-title--list">
            1 500 000 граждан смогут <br> получать эти выплаты <br> ежегодно
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import './article.styl'
import './info.styl'
import Loading from '@/components/Loading/Loading.vue'
import Layers from '@/components/Layers/Layers.vue'
export default {
  name: 'Article6',
  data () {
    return {
      observer: null,
      isLoading: false,
      titles: [
        'История Ольги Бойко похожа на истории тысяч российских женщин',
        'Но стоило кому-то из детей заболеть как тут же возникали проблемы',
        'Но больше всего давит другое: страх потерять деньги, когда каждая копейка на счету, какой небольшой ни была бы зарплата ',
        'Инициативу поддержал президент России',
        '«Родители смогут оказать помощь своим детям»',
        'Все выплаты гарантированы государством и будут идти напрямую из Фонда социального страхования',
        'Новые правила теперь действуют по всей стране',
        'Львова-Белова с супругом воспитывает девятерых детей и еще восемь ребят находится под ее опекой',
        '«Для каждой семьи важно иметь дополнительный ресурс для гармоничного развития ребенка»'
      ]
    }
  },
  components: {
    Loading, Layers
  },
  methods: {
    disable () {
      const target = document.querySelector('#app')
      target.ontouchstart = (e) => {
        e.preventDefault()
      }
    },
    enable () {
      const target = document.querySelector('#app')
      target.ontouchstart = () => {
        return true
      }
    },
    onDone () {
      (document.getElementById('element-container')).classList.remove('-scale', '-no-blue')
      document.querySelector('html').classList.remove('-lock')
      this.enable()
    },

    onIntersection (entries) {
      entries.forEach((entry) => {
        entry.target.classList.toggle('-visible', entry.isIntersecting)

        if (entry.target.classList.contains('-visible')) {
          (document.getElementById('element-container')).classList.add('-scale')

          document.querySelector('html').classList.add('-lock')
          this.disable()
          this.isLoading = true

          setTimeout(() => {
            const layers = document.querySelectorAll('.bottom-layer')
            for (const layer of layers) {
              layer.classList.toggle('is-active')
            };

            this.$scrollTo('#element', 1800, { cancelable: false, offset: -60, onDone: this.onDone, onCancel: this.onDone })

            this.observer.disconnect()
          }, 1500)
        }
      })
    },

    initObserver () {
      this.observer = new IntersectionObserver(this.onIntersection, {
        root: null,
        threshold: 0.5
      })

      const nodes = document.querySelectorAll('.observer-move')

      nodes.forEach((node) => {
        this.observer.observe(node)
      })
    }
  },
  mounted () {
    const titles = []

    this.titles.forEach((item) => {
      titles.push(item.split(' '))
    })
    this.titles = titles

    this.initObserver()
  }
}
</script>

<style scoped lang="stylus">
#element-container
  transition: all 1s ease-out

  &.-no-blue
    background #f9f9f9

    .article-cir__21, .article__line3
      opacity 0

  #element-content
    transform-origin 50% 0
    transition: all 0.4s ease-out

  &.-scale
    #element-content
      transition: none
      transform scale(0.8)

.article__img1
  position: absolute
  width: 20rem
  left: 0
  top: 22rem

.article__img2
  position: absolute
  width: 55rem
  right: 0
  top: 1rem

  @media(max-width: 950px)
    float: right

.article__img3
  position: absolute
  width: 47rem
  left: 0
  top: 0
  z-index: 15

.article__img4
  position: absolute
  width: 47rem
  left: 0
  top: 1rem
  z-index: 15

  @media(max-width: 950px)
    float: left

.article__img5
  position: absolute
  width: 59rem
  left: 0
  top: 0
  z-index: 15

.article__line3
  position: absolute
  width: 38rem
  right: 0
  top: 4rem
  z-index: 4

.article__img6
  position: absolute
  width: 28rem
  right: 0
  top: 0

  @media(max-width: 950px)
    float: right
    width: 15rem
    margin: 0

.article__line4
  position: absolute
  width: 35rem
  left: 0
  top: 4rem
  z-index: 4

.article__img7
  position: absolute
  width: 29rem
  left: 0
  top: 85rem

  @media(max-width: 950px)
    display: none

.article__img8
  position: absolute
  width: 57rem
  left: 0
  top: 10rem
  z-index: 15

  @media(max-width: 950px)
    float: right

.article__line5
  position: absolute
  width: 38rem
  right: 0
  top: 4rem
  z-index: 4

.article__line2
  position: absolute
  width: 47rem
  left: 0
  top: 2.5rem
  z-index: 14

.article__line6
  position: absolute
  right: 3rem
  top: 0
  width: 85rem

.article__img10
  position: absolute
  right: 0
  width: 23rem
  top: 50rem
  z-index: 20

.article__img11
  position: absolute
  right: 5rem
  width: 13rem
  top: 8rem

.article__img12
  position: absolute
  left: 6rem
  width: 11rem
  top: 21rem

.article__img13
  position: absolute
  left: 5rem
  width: 12rem
  top: 50rem

.article__img14
  position: absolute
  left: 3rem
  width: 12rem
  top: 19rem

.article__img15
  position: absolute
  top: 130rem
  right: 3rem
  width: 10rem

.article__img16
  position: absolute
  top: 13rem
  right: 0
  width: 18rem

.article__img17
  position: absolute
  top: 28rem
  left: 5rem
  width: 13rem

</style>
